"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyImageUploadBoxBase = exports.EmptyImageUploadBox = void 0;
var _core = require("@emotion/core");
var _react = _interopRequireWildcard(require("react"));
var _i18n = require("../../../i18n/i18n");
var _useTheme = require("../../../theme/utils/useTheme");
var _typography = require("../../typography");
var _EmptyUploadBoxStyled = require("../styled/EmptyUploadBoxStyled");
var _imageUploaderTheme = require("../styled/imageUploaderTheme");
var _ImageBrowse = require("./ImageBrowse");
var _ImageUploaderIcon = require("./ImageUploaderIcon");
const EmptyImageUploadBoxBase = _ref => {
  let {
    acceptableMimeTypes,
    clientId,
    i18n,
    isDisabled,
    onChange,
    usageType
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const imageBrowserRef = (0, _react.useRef)(null);
  const handleClickUpload = () => {
    if (isDisabled) return;
    imageBrowserRef.current?.click();
  };
  return /*#__PURE__*/_react.default.createElement(_EmptyUploadBoxStyled.EmptyUploadBoxStyled, {
    "aria-disabled": isDisabled,
    onClick: handleClickUpload,
    themeMode: themeMode,
    usageType: usageType
  }, usageType !== "logo" && /*#__PURE__*/_react.default.createElement(_core.ClassNames, null, _ref2 => {
    let {
      cx,
      css
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_ImageUploaderIcon.ImageUploaderIcon, {
      className: cx(isDisabled && css`
                                        opacity: 0.4;
                                        filter: alpha(opacity=40);
                                    `),
      themeMode: themeMode
    });
  }), /*#__PURE__*/_react.default.createElement(_typography.TypeRampV2
  // @ts-expect-error TODO: update TypeRampV2 to accept themeMode directly
  , {
    system: themeMode.split("-")[0],
    variant: _imageUploaderTheme.imageUploaderTheme.dropSpan.variant(themeMode),
    style: {
      color: _imageUploaderTheme.imageUploaderTheme.textColor.default(themeMode),
      marginTop: `${_imageUploaderTheme.imageUploaderTheme.dropSpan.marginTop(themeMode)}px`
    }
  }, usageType === "image" && i18n._( /*i18n*/"Drop your image here"), usageType === "logo" && i18n._( /*i18n*/"Drop your logo here")), /*#__PURE__*/_react.default.createElement(_ImageBrowse.ImageBrowse, {
    ref: imageBrowserRef,
    accept: acceptableMimeTypes.join(","),
    clientId: clientId,
    isDisabled: isDisabled,
    onChange: onChange,
    buttonSize: "small"
  }));
};
exports.EmptyImageUploadBoxBase = EmptyImageUploadBoxBase;
const EmptyImageUploadBox = (0, _i18n.withI18n)(EmptyImageUploadBoxBase);
exports.EmptyImageUploadBox = EmptyImageUploadBox;
//# sourceMappingURL=EmptyImageUploadBox.js.map